import { render } from "./hotel-row.vue?vue&type=template&id=109816d6"
import script from "./hotel-row.vue?vue&type=script&lang=js"
export * from "./hotel-row.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__